import React, { useEffect, useState } from 'react'
import { bool, object, string, func } from 'prop-types'
import ValidacaoFluxosPagamento from '../components/ValidacaoFluxosPagamento'
import EscolhaPlano from './EscolhaPlano'
import { useGlobal } from '../../../contexts/GlobalContext'
import { useModalidade } from '../../../contexts/ModalidadeContext'
import { isEmptyObject } from '../../../utils/helpers/helpers'
import { tiposDePlanos } from '../../../containers/Modalidade/Plano/constantsPlano'

const TelaPlano = ( {
  descricao,
  etapaAtual,
  location,
  isPlanoPresente,
  modalidadeSelecaoPlano,
  primeiraEtapa,
  setIdPlano
} ) => {
  const { modalidadeURL } = useGlobal()
  const { fetchPlanos, listaPlanosPorModalidade } = useModalidade()
  const [ modalidadeParaPlanos, setModalidadeParaPlanos ] = useState( null )
  const [ planosPresente, setPlanosPresente ] = useState( [] )
  const [ planosNaoPresente, setPlanosNaoPresente ] = useState( [] )

  useEffect( () => {
    setModalidadeParaPlanos( modalidadeSelecaoPlano || modalidadeURL )
  }, [ modalidadeSelecaoPlano, modalidadeURL ] )

  useEffect( () => {
    if ( modalidadeParaPlanos ) {
      fetchPlanos( modalidadeParaPlanos )
    }
  }, [ modalidadeParaPlanos ] )

  useEffect( () => {
    if ( !isEmptyObject( listaPlanosPorModalidade ) ) {
      const presente = listaPlanosPorModalidade[ tiposDePlanos.PRESENTE ]
      const naoPresente = listaPlanosPorModalidade[ tiposDePlanos.NAO_PRESENTE ]
      setPlanosPresente( presente )
      setPlanosNaoPresente( naoPresente )
    }
  }, [ listaPlanosPorModalidade ] )

  return (
    <ValidacaoFluxosPagamento
      etapaAtual={ etapaAtual }
      location={ location }
      modalidade={ modalidadeSelecaoPlano || modalidadeURL }
      primeiraEtapa={ primeiraEtapa }
    >
      <EscolhaPlano
        descricao={ descricao }
        etapaAtual={ etapaAtual }
        listaPlanos={ isPlanoPresente ? planosPresente : planosNaoPresente }
        modalidade={ modalidadeSelecaoPlano || modalidadeURL }
        setIdPlano={ setIdPlano }
      />
    </ValidacaoFluxosPagamento>
  )
}

TelaPlano.defaultProps = {
  'isPlanoPresente': false,
  'modalidadeSelecaoPlano': null,
  'setIdPlano': () => {}
}

TelaPlano.propTypes = {
  'descricao': string.isRequired,
  'etapaAtual': object.isRequired,
  'isPlanoPresente': bool,
  'location': object.isRequired,
  'modalidadeSelecaoPlano': string,
  'primeiraEtapa': string.isRequired,
  'setIdPlano': func,
}

export default TelaPlano

